import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {FileHelper} from '../../helpers/file-helper';
import {formatPhone, formatPhoneNumeric, toDateString} from '../../providers/app-date-adapter';
import {RiskService} from '../services/risk.service';

import {RiskOverviewService} from '../services/risk-overview.service';
import {FormControl} from '@angular/forms';
import {RiskLevel} from '../../dto/risk-level';
import {CustomerRisk} from '../../dto/customer-risk';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RiskLevelStatsModel} from '../../models/risk-level-stats-model';
import {CardActivationImport} from '../../dto/card-activation-import';
import {Company} from '../../dto/company';
import {CompanyService} from '../services/company.service';


@Component( {
  selector: 'app-risk',
  templateUrl: './risk.component.html',
  styleUrls: [ './risk.component.css' ],
} )
export class RiskComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private changeDetectorRefs: ChangeDetectorRef,
    private riskOverviewService: RiskOverviewService,
    private riskService: RiskService,
    private snackBar: MatSnackBar,
    private companyService: CompanyService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  public riskLevelSelect = new FormControl();
  public riskLevel = RiskLevel;

  stats: RiskLevelStatsModel = null;
  isLoadingStats = false;

  activeInquiries = 0;
  companyFilter: string[] = [];

  companies: Company[];

  dataSource = new MultiCrudDataSource( this.riskOverviewService );

  columns = [

    { columnDef: 'title', header: 'Title', cell: (row: CustomerRisk) => `${row.title}` },
    { columnDef: 'firstName', header: 'First name', cell: (row: CustomerRisk) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last name', cell: (row: CustomerRisk) => `${row.lastName}` },
    { columnDef: 'address', header: 'Address', cell: (row: CustomerRisk) => `${row.address}` },
    { columnDef: 'city', header: 'City', cell: (row: CustomerRisk) => `${row.city}` },
    { columnDef: 'zipCode', header: 'Zip code', cell: (row: CustomerRisk) => `${row.zipCode}` },
    { columnDef: 'email', header: 'Email', cell: (row: CustomerRisk) => `${row.email}` },
    { columnDef: 'phone', header: 'Mobile', cell: (row: CustomerRisk) => `${formatPhoneNumeric(row.phone)}` },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: CustomerRisk) => `${toDateString(row.dob)}` },
    // { columnDef: "cardsCount", header: "Cards", cell: ( row: CustomerRisk ) => `${ row.cards.length }` },
    { columnDef: 'risk', header: 'Risk Level', cell: ( row: CustomerRisk ) => {

      let lvl = 0;

      if ( row.riskLevelOverride != null ) {
        lvl = row.riskLevelOverride;
      } else {
        lvl = row.riskLevel;
      }

      if ( lvl != null  ) {

        if ( lvl == 0 ) {
          return 'low';
        }

        if ( lvl == 1 ) {
          return 'medium';
        }

        if ( lvl == 2 ) {
          return 'high';
        }

      }

      }},
    { columnDef: 'riskSumLoadSepaCount', header: 'Sepa count', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSepaCount || '' }` },
    { columnDef: 'riskSumLoadSepa', header: 'Sepa sum', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSepa || '' }` },
    { columnDef: 'riskSumLoadSofortCount', header: 'Sofort count', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSofortCount || '' }` },
    { columnDef: 'riskSumLoadSofort', header: 'Sofort sum', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSofort || '' }` },

    { columnDef: 'riskSumBankTransferLoadCount', header: 'BTL count', cell: ( row: CustomerRisk ) => `${ row.riskSumBankTransferLoadCount || '' }` },
    { columnDef: 'riskSumBankTransferLoad', header: 'BTL sum', cell: ( row: CustomerRisk ) => `${ row.riskSumBankTransferLoad || '' }` },

    { columnDef: 'riskSumLoadTotal', header: 'Total load sum', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadTotal || '' }` },




  ];


  currentUserIsAdminOrCompliance() {

    if ( this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance') ) {
      return true;
    }

    return false;

  }

  currentUserIsPartner() {

    return this.roleService.hasRoles('partner');

  }

  onRiskLevelChange() {
    this.table.filters.enumFilter = { key: 'RiskLevel', value: this.riskLevelSelect.value };
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }

  clearFilter() {
    this.riskLevelSelect.patchValue(null);

    // this.multiButton.buttonToggleGroup.value = "";

    this.table.clearFilter();
  }

  currentUserIsAdminOrManagerOrCompliance() {
    return this.roleService.hasRoles('admin') || this.roleService.hasRoles('manager') || this.roleService.hasRoles('compliance');
  }

  ngOnInit() {

    this.companyService.getAll().subscribe( x => {
      this.companies = x.data;
    });
    this.getActiveRiskInquiries();
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );
    this.isLoadingStats = true;
    this.riskOverviewService.getStats(this.companyFilter).subscribe(result => {
      this.stats = result;
      this.isLoadingStats = false;
    });

  }
  getActiveRiskInquiries() {
    if (!this.currentUserIsPartner()) {
      this.riskService.getActiveInquiries().subscribe(result => {
        this.activeInquiries = result;
      });
    }
  }

  getCustomerOverviewLink = (item: CustomerRisk): string => '/customers-overview/' + item.id.toString();

  getRowClass = (row: any): string => {


    let lvl = 0;

    if ( row.riskLevelOverride != null ) {
      lvl = row.riskLevelOverride;
    } else {
      lvl = row.riskLevel;
    }

    if ( lvl != null  ) {

      if ( lvl == 0 ) {
        return 'risk-low';
      }

      if ( lvl == 1 ) {
        return 'risk-medium';
      }

      if ( lvl == 2 ) {
        return 'risk-high';
      }

    }

    return '';


  };
  isDownloadingRiskReport = false;
  isDownloadingCardActivitiesReport = false;
  isDownloadingNonAllGoodCardsReport = false;


  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.riskOverviewService.getStats(this.table.filters.companiesFilter).subscribe(result => {
        this.stats = result;
        this.isLoadingStats = false;
      });
      this.table.applyFilter();
    }
  }

  downloadRiskReport() {
    this.isDownloadingRiskReport = true;
    this.riskOverviewService.getReportCsv(
      0,
      99999999,
      this.table.filters.sortField,
      this.table.filters.sortDirection,
      this.table.filters.str,
      this.table.filters.dateFilterCols,
      this.table.filters.startFilterDate,
      this.table.filters.endFilterDate,
      this.table.filters.someAdditionalData,
      this.table.filters.additionalFilterData,
      this.table.filters.enumFilter,
      this.table.filters.companiesFilter,
      this.table.filters.additionalField1,
      this.table.filters.additionalField2,
      this.table.filters.additionalValue1,
      this.table.filters.additionalValue2
    ) .subscribe(
      result => {
        FileHelper.saveFile(result);
        this.isDownloadingRiskReport = false;
      },
      err => {
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        });
        this.isDownloadingRiskReport = false;
      }

    );
  }

  downloadCardActivitiesReport() {
    this.isDownloadingCardActivitiesReport = true;
    this.riskOverviewService.getCardActivitiesReportCsv(
      0,
      99999999,
      this.table.filters.sortField,
      this.table.filters.sortDirection,
      this.table.filters.str,
      this.table.filters.dateFilterCols,
      this.table.filters.startFilterDate,
      this.table.filters.endFilterDate,
      this.table.filters.someAdditionalData,
      this.table.filters.additionalFilterData,
      this.table.filters.enumFilter,
      this.table.filters.companiesFilter,
      this.table.filters.additionalField1,
      this.table.filters.additionalField2,
      this.table.filters.additionalValue1,
      this.table.filters.additionalValue2
    ) .subscribe(
      result => {
        FileHelper.saveFile(result);
        this.isDownloadingCardActivitiesReport = false;
      },
      err => {
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ["app-mat-snack-bar"]
        });
        this.isDownloadingCardActivitiesReport = false;
      }
    );
  }

  downloadNonAllGoodCardsReport() {
    this.isDownloadingNonAllGoodCardsReport = true;
    this.riskOverviewService.getNonAllGoodCardsReportCsv(
      0,
      99999999,
      this.table.filters.sortField,
      this.table.filters.sortDirection,
      this.table.filters.str,
      this.table.filters.dateFilterCols,
      this.table.filters.startFilterDate,
      this.table.filters.endFilterDate,
      this.table.filters.someAdditionalData,
      this.table.filters.additionalFilterData,
      this.table.filters.enumFilter,
      this.table.filters.companiesFilter,
      this.table.filters.additionalField1,
      this.table.filters.additionalField2,
      this.table.filters.additionalValue1,
      this.table.filters.additionalValue2
    ) .subscribe(
      result => {
        FileHelper.saveFile(result);
        this.isDownloadingNonAllGoodCardsReport = false;
      },
      err => {
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ["app-mat-snack-bar"]
        });
        this.isDownloadingNonAllGoodCardsReport = false;
      }
    );
  }


  currentUserIsIssuerExternal() {
    return this.roleService.hasRoles('issuer_external');
  }
}
